[
  {
    "code": "default",
    "medidas": {
      "deck_left": "20px",
      "deck_top": "-75px",
      "miniature_left": "-20px",
      "miniature_top": "-6px",
      "miniature_height": "102px",
      "miniature_width": "68px"
    }
  },
  {
    "code": "04SI055",
    "medidas": {
      "miniature_top": "-14px",
      "miniature_left": "-29px",
      "deck_top": "-72px",
      "deck_left": "0px"
    }
  },
  {
    "code": "01PZ056",
    "medidas": {
      "miniature_top": "-18px",
      "miniature_left": "-15px",
      "deck_top": "-98px",
      "deck_left": "23px"
    }
  },
  {
    "code": "04BW005",
    "medidas": {
      "miniature_top": "-8px",
      "miniature_left": "-23px",
      "deck_top": "-84px",
      "deck_left": "17px"
    }
  },
  {
    "code": "04SH019",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-25px",
      "deck_top": "-62px",
      "deck_left": "54px"
    }
  },
  {
    "code": "04MT008",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-26px",
      "deck_top": "-60px",
      "deck_left": "25px"
    }
  },
  {
    "code": "04SH047",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-10px",
      "deck_top": "-57px",
      "deck_left": "35px"
    }
  },
  {
    "code": "04SH020",
    "medidas": {
      "miniature_top": "-17px",
      "miniature_left": "-6px",
      "deck_top": "-78px",
      "deck_left": "94px"
    }
  },
  {
    "code": "04SH073",
    "medidas": {
      "miniature_top": "-14px",
      "miniature_left": "-3px",
      "deck_top": "-70px",
      "deck_left": "85px"
    }
  },
  {
    "code": "01DE045",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-30px",
      "deck_top": "-85px",
      "deck_left": "6px"
    }
  },
  {
    "code": "04SH003",
    "medidas": {
      "miniature_top": "-14px",
      "miniature_left": "-10px",
      "deck_top": "-65px",
      "deck_left": "85px"
    }
  },
  {
    "code": "04SI005",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-28px",
      "deck_top": "-70px",
      "deck_left": "14px"
    }
  },
  {
    "code": "03MT217",
    "medidas": {
      "miniature_top": "-8px",
      "miniature_left": "-33px",
      "miniature_height": "107px",
      "miniature_width": "76px",
      "deck_top": "-78px",
      "deck_left": "46px"
    }
  },
  {
    "code": "04NX004",
    "medidas": {
      "miniature_top": "-12px",
      "miniature_left": "-18px",
      "deck_top": "-81px",
      "deck_left": "36px"
    }
  },
  {
    "code": "04DE008",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-17px",
      "deck_top": "-55px",
      "deck_left": "13px"
    }
  },
  {
    "code": "04SH067",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-30px",
      "deck_top": "-62px",
      "deck_left": "54px"
    }
  },
  {
    "code": "01SI053",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-15px",
      "deck_top": "-58px",
      "deck_left": "62px"
    }
  },
  {
    "code": "01PZ040",
    "medidas": {
      "miniature_top": "-19px",
      "miniature_left": "-8px",
      "deck_top": "-106px",
      "deck_left": "62px"
    }
  },
  {
    "code": "01DE022",
    "medidas": {
      "miniature_top": "-14px",
      "miniature_left": "-7px",
      "deck_top": "-77px",
      "deck_left": "36px"
    }
  },
  {
    "code": "02BW022",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-29px",
      "deck_top": "-70px",
      "deck_left": "0px"
    }
  },
  {
    "code": "03SI005",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-24px",
      "deck_top": "-71px",
      "deck_left": "12px"
    }
  },
  {
    "code": "03MT058",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-13px",
      "deck_top": "-72px",
      "deck_left": "54px"
    }
  },
  {
    "code": "01NX038",
    "medidas": {
      "miniature_top": "-13px",
      "miniature_left": "-20px",
      "deck_top": "-72px",
      "deck_left": "73px"
    }
  },
  {
    "code": "01IO009",
    "medidas": {
      "miniature_top": "-13px",
      "miniature_left": "-15px",
      "deck_top": "-75px",
      "deck_left": "103px"
    }
  },
  {
    "code": "03DE011",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-13px",
      "deck_top": "-65px",
      "deck_left": "56px"
    }
  },
  {
    "code": "01DE012",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-26px",
      "deck_top": "-61px",
      "deck_left": "28px"
    }
  },
  {
    "code": "02BW046",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-10px",
      "deck_top": "-69px",
      "deck_left": "65px"
    }
  },
  {
    "code": "03PZ003",
    "medidas": {
      "miniature_top": "-21px",
      "miniature_left": "-44px",
      "miniature_width": "100px",
      "miniature_height": "120px",
      "deck_top": "-78px",
      "deck_left": "42px"
    }
  },
  {
    "code": "03IO002",
    "medidas": {
      "miniature_top": "-16px",
      "miniature_left": "-19px",
      "deck_top": "-72px",
      "deck_left": "39px"
    }
  },
  {
    "code": "01SI030",
    "medidas": {
      "miniature_top": "-12px",
      "miniature_left": "-13px",
      "deck_top": "-60px",
      "deck_left": "38px"
    }
  },
  {
    "code": "02PZ008",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-12px",
      "deck_top": "-60px",
      "deck_left": "57px"
    }
  },
  {
    "code": "01PZ008",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-17px",
      "deck_top": "-88px",
      "deck_left": "52px"
    }
  },
  {
    "code": "03MT009",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-15px",
      "deck_top": "-90px",
      "deck_left": "66px"
    }
  },
  {
    "code": "03MT056",
    "medidas": {
      "miniature_top": "-13px",
      "miniature_left": "-20px",
      "miniature_width": "77px",
      "miniature_height": "110px",
      "deck_top": "-65px",
      "deck_left": "75px"
    }
  },
  {
    "code": "04SH130",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-17px",
      "deck_top": "-65px",
      "deck_left": "115px"
    }
  },
  {
    "code": "04SH039",
    "medidas": {
      "miniature_top": "-7px",
      "miniature_left": "-16px",
      "deck_top": "-67px",
      "deck_left": "11px"
    }
  },
  {
    "code": "04IO005",
    "medidas": {
      "miniature_top": "-12px",
      "miniature_left": "-10px",
      "deck_top": "-57px",
      "deck_left": "32px"
    }
  },
  {
    "code": "04FR005",
    "medidas": {
      "miniature_top": "-6px",
      "miniature_left": "-20px",
      "deck_top": "-69px",
      "deck_left": "25px"
    }
  },
  {
    "code": "03NX007",
    "medidas": {
      "miniature_top": "-15px",
      "miniature_left": "-26px",
      "deck_top": "-70px",
      "deck_left": "32px"
    }
  },
  {
    "code": "01PZ036",
    "medidas": {
      "miniature_top": "\t-7px",
      "miniature_left": "-20px",
      "deck_top": "-57px",
      "deck_left": "95px"
    }
  },
  {
    "code": "01NX042",
    "medidas": {
      "miniature_top": "-6px",
      "miniature_left": "-20px",
      "deck_top": "-58px",
      "deck_left": "30px"
    }
  },
  {
    "code": "03MT055",
    "medidas": {
      "miniature_top": "-6px",
      "miniature_left": "-20px",
      "deck_top": "-61px",
      "deck_left": "52px"
    }
  },
  {
    "code": "04PZ001",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-15px",
      "deck_top": "-59px",
      "deck_left": "27px"
    }
  },
  {
    "code": "02SI008",
    "medidas": {
      "miniature_top": "-14px",
      "miniature_left": "-24px",
      "deck_top": "-75px",
      "deck_left": "62px"
    }
  },
  {
    "code": "03BW004",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-7px",
      "miniature_width": "49px",
      "deck_top": "-76px",
      "deck_left": "58px"
    }
  },
  {
    "code": "01IO015",
    "medidas": {
      "miniature_top": "-6px",
      "miniature_left": "-20px",
      "deck_top": "-53px",
      "deck_left": "47px"
    }
  },
  {
    "code": "01IO032",
    "medidas": {
      "miniature_top": "-6px",
      "miniature_left": "-20px",
      "deck_top": "-73px",
      "deck_left": "103px"
    }
  },
  {
    "code": "01FR009",
    "medidas": {
      "miniature_top": "-17px",
      "miniature_left": "-26px",
      "deck_top": "-75px",
      "deck_left": "23px"
    }
  },
  {
    "code": "01FR038",
    "medidas": {
      "miniature_top": "-13px",
      "miniature_left": "-14px",
      "deck_top": "-63px",
      "deck_left": "84px"
    }
  },
  {
    "code": "02BW026",
    "medidas": {
      "miniature_top": "-6px",
      "miniature_left": "-20px",
      "deck_top": "-66px",
      "deck_left": "76px"
    }
  },
  {
    "code": "03MT054",
    "medidas": {
      "miniature_top": "-6px",
      "miniature_left": "-20px",
      "deck_top": "-53px",
      "deck_left": "45px"
    }
  },
  {
    "code": "02IO006",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-19px",
      "deck_top": "-69px",
      "deck_left": "34px"
    }
  },
  {
    "code": "02DE006",
    "medidas": {
      "miniature_top": "-13px",
      "miniature_left": "-13px",
      "deck_top": "-70px",
      "deck_left": "56px"
    }
  },
  {
    "code": "02DE006",
    "medidas": {
      "miniature_top": "-6px",
      "miniature_left": "-20px",
      "deck_top": "-65px",
      "deck_left": "19px"
    }
  },
  {
    "code": "02NX007",
    "medidas": {
      "miniature_top": "-14px",
      "miniature_left": "-23px",
      "deck_top": "-65px",
      "deck_left": "22px"
    }
  },
  {
    "code": "01SI052",
    "medidas": {
      "miniature_top": "-7px",
      "miniature_left": "-20px",
      "deck_top": "-60px",
      "deck_left": "92px"
    }
  },
  {
    "code": "01NX006",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-27px",
      "deck_top": "-58px",
      "deck_left": "28px"
    }
  },
  {
    "code": "01IO041",
    "medidas": {
      "miniature_top": "-18px",
      "miniature_left": "-20px",
      "deck_top": "-72px",
      "deck_left": "60px"
    }
  },
  {
    "code": "02BW032",
    "medidas": {
      "miniature_top": "-8px",
      "miniature_left": "-12px",
      "deck_top": "-63px",
      "deck_left": "50px"
    }
  },
  {
    "code": "02FR002",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-21px",
      "deck_top": "-72px",
      "deck_left": "43px"
    }
  },
  {
    "code": "01SI042",
    "medidas": {
      "miniature_top": "-7px",
      "miniature_left": "-20px",
      "deck_top": "-55px",
      "deck_left": "42px"
    }
  },
  {
    "code": "03FR006",
    "medidas": {
      "miniature_top": "-13px",
      "miniature_left": "-18px",
      "deck_top": "-68px",
      "deck_left": "68px"
    }
  },
  {
    "code": "01FR024",
    "medidas": {
      "miniature_top": "-8px",
      "miniature_left": "-20px",
      "deck_top": "-57px",
      "deck_left": "96px"
    }
  },
  {
    "code": "02BW053",
    "medidas": {
      "miniature_top": "-15px",
      "miniature_left": "-26px",
      "deck_top": "-60px",
      "deck_left": "11px"
    }
  },
  {
    "code": "01FR039",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-21px",
      "deck_top": "-63px",
      "deck_left": "37px"
    }
  },
  {
    "code": "03MT087",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-24px",
      "miniature_height": "111px",
      "deck_top": "-106px",
      "deck_left": "18px"
    }
  },
  {
    "code": "01DE042",
    "medidas": {
      "miniature_top": "-15px",
      "miniature_left": "-10px",
      "deck_top": "-72px",
      "deck_left": "84px"
    }
  },
  {
    "code": "01NX020",
    "medidas": {
      "miniature_top": "-12px",
      "miniature_left": "-24px",
      "deck_left": "0px",
      "deck_top": "-75px"
    }
  },
  {
    "code": "05PZ006",
    "medidas": {
      "miniature_top": "-8px",
      "miniature_left": "-25px",
      "deck_left": "95px",
      "deck_top": "-76px"
    }
  },
  {
    "code": "05BC041",
    "medidas": {
      "miniature_top": "-16px",
      "miniature_left": "-16px",
      "deck_left": "32px",
      "deck_top": "-75px"
    }
  },
  {
    "code": "05BC093",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-20px",
      "deck_left": "36px",
      "deck_top": "-75px"
    }
  },
  {
    "code": "05SI009",
    "medidas": {
      "miniature_top": "-8px",
      "miniature_left": "-20px",
      "miniature_height": "110px",
      "deck_left": "79px",
      "deck_top": "-76px"
    }
  },
  {
    "code": "05BC133",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-12px",
      "miniature_height": "110px",
      "deck_left": "36px",
      "deck_top": "-66px"
    }
  },
  {
    "code": "05NX001",
    "medidas": {
      "miniature_top": "-15px",
      "miniature_left": "-23px",
      "miniature_width": "70px",
      "miniature_height": "141px",
      "deck_left": "49px",
      "deck_top": "-59px"
    }
  },
  {
    "code": "05SH014",
    "medidas": {
      "deck_left": "36px",
      "deck_top": "-73px",
      "miniature_left": "-15px",
      "miniature_top": "-14px"
    }
  },
  {
    "code": "05BC163",
    "medidas": {
      "deck_left": "27px",
      "deck_top": "-75px",
      "miniature_left": "-16px",
      "miniature_top": "-14px"
    }
  },
  {
    "code": "05PZ022",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-17px",
      "deck_top": "-50px",
      "deck_left": "75px"
    }
  },
  {
    "code": "05BC058",
    "medidas": {
      "miniature_top": "-12px",
      "miniature_left": "-9px",
      "deck_top": "-75px",
      "deck_left": "42px"
    }
  },
  {
    "code": "05MT003",
    "medidas": {
      "miniature_top": "-11px",
      "miniature_left": "-17px",
      "deck_top": "-71px",
      "deck_left": "75px"
    }
  },
  {
    "code": "05BC088",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-17px",
      "deck_top": "-54px",
      "deck_left": "63px"
    }
  },
  {
    "code": "05IO004",
    "medidas": {
      "deck_top": "-90px",
      "deck_left": "48px"
    }
  },
  {
    "code": "05BC029",
    "medidas": {
      "miniature_top": "-10px",
      "miniature_left": "-17px",
      "deck_top": "-84px",
      "deck_left": "32px"
    }
  },
  {
    "code": "05DE009",
    "medidas": {
      "miniature_top": "-13px",
      "miniature_left": "-20px",
      "deck_top": "-61px",
      "deck_left": "32px"
    }
  },
  {
    "code": "05FR013",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-20px",
      "deck_top": "-56px",
      "deck_left": "75px"
    }
  },
  {
    "code": "05BC161",
    "medidas": {
      "miniature_height": "115px",
      "miniature_width": "76px",
      "miniature_top": "-16px",
      "miniature_left": "-17px",
      "deck_top": "-84px",
      "deck_left": "14px"
    }
  },
  {
    "code": "06RU002",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-17px",
      "deck_top": "-61px",
      "deck_left": "55px"
    }
  },
  {
    "code": "06BW006",
    "medidas": {
      "miniature_top": "-12px",
      "miniature_left": "-22px",
      "miniature_height": "113px",
      "miniature_width": "72px",
      "deck_top": "-67px",
      "deck_left": "75px"
    }
  },
  {
    "code": "06RU001",
    "medidas": {
      "miniature_top": "-8px",
      "miniature_left": "-17px",
      "deck_top": "-61px",
      "deck_left": "85px"
    }
  },
  {
    "code": "06NX012",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-17px",
      "deck_top": "-82px",
      "deck_left": "0px"
    }
  },
  {
    "code": "06SH009",
    "medidas": {
      "miniature_top": "-12px",
      "miniature_left": "-23px",
      "deck_top": "-79px",
      "deck_left": "101px"
    }
  },
  {
    "code": "06SI012",
    "medidas": {
      "miniature_left": "-20px",
      "miniature_top": "-6px",
      "deck_top": "-59px",
      "deck_left": "10px"
    }
  },
  {
    "code": "06RU025",
    "medidas": {
      "miniature_left": "-24px",
      "miniature_top": "-6px",
      "deck_top": "-57px",
      "deck_left": "49px"
    }
  },
  {
    "code": "06RU005",
    "medidas": {
      "miniature_left": "-21px",
      "miniature_top": "-16px",
      "miniature_height": "114px",
      "miniature_width": "82px",
      "deck_top": "-93px",
      "deck_left": "65px"
    }
  },
  {
    "code": "06IO008",
    "medidas": {
      "miniature_left": "-23px",
      "miniature_top": "-8px",
      "miniature_height": "107px",
      "miniature_width": "74px",
      "deck_top": "-83px",
      "deck_left": "75px"
    }
  },
  {
    "code": "06BC015",
    "medidas": {
      "miniature_left": "-15px",
      "miniature_top": "-10px",
      "deck_top": "-78px",
      "deck_left": "105px"
    }
  },
  {
    "code": "06RU008",
    "medidas": {
      "miniature_left": "-24px",
      "miniature_top": "-10px",
      "deck_top": "-63px",
      "deck_left": "56px"
    }
  },
  {
    "code": "06FR011",
    "medidas": {
      "miniature_height": "102px",
      "miniature_width": "68px",
      "miniature_left": "-20px",
      "miniature_top": "-6px",
      "deck_top": "-78px",
      "deck_left": "53px"
    }
  },
  {
    "code": "06RU009",
    "medidas": {
      "miniature_left": "-17px",
      "miniature_top": "-9px",
      "deck_top": "-58px",
      "deck_left": "55px"
    }
  },
  {
    "code": "06PZ021",
    "medidas": {
      "miniature_left": "-20px",
      "miniature_top": "-12px",
      "deck_top": "-56px",
      "deck_left": "80px"
    }
  },
  {
    "code": "06DE021",
    "medidas": {
      "miniature_left": "-16px",
      "miniature_top": "-11px",
      "deck_top": "-69px",
      "deck_left": "53px"
    }
  },
  {
    "code": "06RU026",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-10px",
      "deck_top": "-64px",
      "deck_left": "70px"
    }
  },
  {
    "code": "06RU006",
    "medidas": {
      "miniature_top": "-9px",
      "miniature_left": "-19px",
      "deck_top": "-60px",
      "deck_left": "64px"
    }
  },
  {
    "code": "06MT008",
    "medidas": {
      "miniature_top": "-12px",
      "miniature_left": "-13px",
      "deck_top": "-75px",
      "deck_left": "60px"
    }
  },
  {
    "code": "07NX007",
    "medidas": {
      "miniature_left": "-26px",
      "miniature_top": "-8px",
      "miniature_width": "81px",
      "miniature_height": "117px",
      "deck_top": "-54px",
      "deck_left": "25px"
    }
  },
  {
    "code": "07IO011",
    "medidas": {
      "miniature_left": "-15px",
      "miniature_top": "-13px",
      "deck_top": "-80px",
      "deck_left": "35px"
    }
  },
  {
    "code": "07BW002",
    "medidas": {
      "miniature_left": "-26px",
      "miniature_top": "-11px",
      "deck_top": "-56px",
      "deck_left": "53px"
    }
  },
  {
    "code": "07RU015",
    "medidas": {
      "miniature_left": "-20px",
      "miniature_top": "-9px",
      "deck_top": "-50px",
      "deck_left": "61px"
    }
  },
  {
    "code": "07RU012",
    "medidas": {
      "miniature_left": "-21px",
      "miniature_top": "-10px",
      "deck_top": "-76px",
      "deck_left": "19px"
    }
  },
  {
    "code": "07SH013",
    "medidas": {
      "miniature_left": "-27px",
      "miniature_top": "-10px",
      "deck_top": "-66px",
      "deck_left": "69px"
    }
  },
  {
    "code": "08FR001",
    "medidas": {
      "miniature_left": "-13px",
      "miniature_top": "-9px",
      "deck_top": "-60px",
      "deck_left": "20px"
    }
  },
  {
    "code": "08BW008",
    "medidas": {
      "miniature_left": "-19px",
      "miniature_top": "-10px",
      "deck_top": "-70px",
      "deck_left": "56px"
    }
  },
  {
    "code": "08PZ001",
    "medidas": {
      "miniature_left": "-15px",
      "miniature_top": "-7px",
      "deck_top": "-58px",
      "deck_left": "12px"
    }
  },
  {
    "code": "08MT003",
    "medidas": {
      "miniature_left": "-16px",
      "miniature_top": "-13px",
      "deck_top": "-58px",
      "deck_left": "14px"
    }
  },
  {
    "code": "08SI042",
    "medidas": {
      "deck_top": "-61px",
      "deck_left": "0px"
    }
  },
  {
    "code": "08RU014",
    "medidas": {
      "deck_top": "-86px",
      "deck_left": "82px",
      "miniature_height": "152px",
      "miniature_left": "-26px",
      "miniature_top": "-15px"
    }
  },
  {
    "code": "09IO052",
    "medidas": {
      "deck_top": "-62px",
      "deck_left": "27px",
      "miniature_left": "-22px",
      "miniature_top": "-6px"
    }
  },
  {
    "code": "09DE034",
    "medidas": {
      "deck_top": "-69px",
      "deck_left": "67px"
    }
  },
  {
    "code": "09BC001",
    "medidas": {
      "deck_top": "-75px",
      "deck_left": "39px",
      "miniature_left": "-20px",
      "miniature_top": "-14px"
    }
  }
]
